import { memo } from 'react';
import ChatCheckIcon from '@icons/ChatCheckIcon/ChatCheckIcon';
import styles from './TableHeaderSelect.module.scss';

interface ITableHeaderSelectProps {
  selected?: boolean;
  onSelect?: () => void;
  column?: boolean;
}

function TableHeaderSelectComponent({
  selected,
  onSelect,
  column,
}: ITableHeaderSelectProps) {
  return (
    <div className={styles.tableHeaderSelectBox}>
      <button
        type="button"
        onClick={onSelect}
        disabled={!onSelect}
        className={`${styles.tableHeaderSelect} ${selected ? styles.selected : ''}`}
      >
        {selected ? (
          <ChatCheckIcon stroke="#2479BF" />
        ) : (
          column && <div className={styles.line} />
        )}
      </button>
    </div>
  );
}

const TableHeaderSelect = memo(TableHeaderSelectComponent);

export default TableHeaderSelect;
